<template>
    <div id="pricing"
          ref="pricing" class="content-inner formValidation">
        <div class="row" v-if="!is_reviewing">
            <div class="col-12">
                <div class="panel-sub-heading headingLarge">
                     <span class="h5 display-6 markedBottom bold">{{ lang('pricing') }}
                </span>
                </div>
            </div>
        </div>
        <div class="row">
<!--            TODO rewrite the checks for the skeletons for loading. check that quote is loaded, the service and charge items are loaded, else keep showing skeletons-->
            <div id="service-fees" class="col-12">
                <div class="panel panel-default">
                    <div class="panel-heading">
                               <span>
                        {{ lang('elavon_service_fees') }}
                    </span>
                    </div>
                    <div class="row">
                        <np-skeleton class="col-12" v-if="loading" :type="'fees'"></np-skeleton>
                        <template v-if="!loading && !!quote.acquiring_offer && quote.acquiring_offer.service_items.length > 0">
                            <template v-for="(service_item, service_idx) in quote.acquiring_offer.service_items">
                                <div class="col-6 col-md-6 col-lg-4"
                                    v-show="service_item.is_invisible == '0' && service_item.is_boarding_activated === '1'
                                    && service_item.is_hidden_by_fee_control !== '1'">
                                    <div class="card marginBottom20"
                                         :class="{'card--selected-pricing': service_item.is_boarding_activated === '1'}">
                                        <div class="card-header card-header--pricing">
                                            <div class="row">
                                                <div class="col-12">
                                                     <span>
                                                        {{ service_item.service_item_name }}
                                                           <span v-if="!!service_item.help_text && service_item.help_text.length > 0"
                                                                   :title="service_item.service_item_name"
                                                                   :data-popover-content="!!service_item.help_text ? service_item.help_text : ''"
                                                                   class="helpBtn addPopover helpHeader">
                                                                    <i tabindex="-1"
                                                                       class="fa fa-info-circle"></i>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="row fee-block marginBottom10">
                                                <div class="col-12">
                                                    {{formatServiceFrequency(service_item.service_frequency) }}
                                                </div>
                                                <div class="col-12 fee-name"
                                                     v-if="!!service_item.service_item_charges"
                                                     v-for="(service_item_charge) in service_item.service_item_charges">
                                                    <div class="fontSize15 display-inline-block">
                                                        <span>{{ getPricingFee(service_item_charge, service_item) }} </span>
                                                    </div>

                                                    <!--                                                        <div class="fontSize15 display-inline-block"-->
                                                    <!--                                                             v-if="service_item_charge.fee_type == 1">-->
                                                    <!--                                                            <span>{{ convertToDecimal(service_item_charge.default_perc_charge) }}% </span>-->
                                                    <!--                                                        </div>-->
                                                    <!--                                                        <div class="fontSize15 display-inline-block"-->
                                                    <!--                                                             v-if="service_item_charge.fee_type == 2">-->
                                                    <!--                                                            <span>{{ formatFee(service_item_charge.default_base_charge, service_item.charge_decimals) }}p</span>-->
                                                    <!--                                                        </div>-->
                                                    <!--                                                        <div v-if="service_item_charge.fee_type == 3"-->
                                                    <!--                                                             class="charge-wrapper">-->
                                                    <!--                                                            <div class="fontSize15 display-inline-block">-->
                                                    <!--                                                                <span>{{ convertToDecimal(service_item_charge.default_perc_charge) }}%</span>-->
                                                    <!--                                                            </div>-->
                                                    <!--                                                            <span class="fontSize15 display-inline-block">+</span>-->
                                                    <!--                                                            <div class="fontSize15 display-inline-block">-->
                                                    <!--                                                                <span>{{ formatFee(service_item_charge.default_base_charge, service_item.charge_decimals) }}p</span>-->
                                                    <!--                                                            </div>-->
                                                    <!--                                                        </div>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <div v-else-if="!loading && !!quote.acquiring_offer && quote.acquiring_offer.service_items.length < 1" class="col-12">
                            <np-notice :notice-class="'alert-info'" :notice="lang('no_pricing_available')"
                                       :dismissable="false"
                            ></np-notice>
                        </div>
                    </div>
                </div>
            </div>
            <div id="transaction-fees" class="col-12">
                <div class="panel panel-default">
                    <div class="panel-heading">
                         <span>
                            {{ lang('elavon_transaction_fees') }}
                         <span   v-if="getTooltipText('elavon_transaction_fees_help_text').length > 0"
                                 :title="lang('elavon_transaction_fees')"
                                 :data-popover-content="getTooltipText('elavon_transaction_fees_help_text')"
                                 style="display: inline-block; padding: 0;"
                                 class="helpBtn addPopover helpHeader">
                                 <i tabindex="-1" class="fa fa-info-circle"></i>
                             </span>
                    </span>
                    </div>
                    <div class="row">
                        <template v-if="mode === 'card'">
                            <np-skeleton class="col-12" v-if="loading" :type="'pricing'"></np-skeleton>
                            <template v-if="!loading && !!quote.acquiring_offer && quote.acquiring_offer.charge_items.length > 0"
                                      v-for="(charge_item, charge_idx) in quote.acquiring_offer.charge_items">
                                <div class="col-6 col-md-6 col-lg-6"
                                     v-show="charge_item.is_invisible == '0' && charge_item.is_boarding_activated == '1'">
                                    <div class="card marginBottom20"
                                         :class="{'card--selected-pricing': charge_item.is_boarding_activated == '1'}">
                                        <div class="card-header card-header--pricing">
                                            <div class="row">
                                                <div class="col-10">
                                                    {{ charge_item.charge_item_name }}
                                                </div>
                                                <div class="col-2">
                                                    <span style="float: right;  margin-top: -6px;"
                                                          :class="getCardType(charge_item.charge_item_name)"></span>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="card-body">
                                            <div class="row fee-block marginBottom10">
                                                <div class="col-6" v-for="(tier, index) in charge_item.charge_item_prices">
                                                    <!--     TODO confim tier to show? Display first tier price only for now-->
                                                    <div class="row" v-if="index == 0"
                                                         v-for="(tier_charge) in tier.charge_item_price_charges">
                                                        <div class="col-12 fee-name">
                                                            <span
                                                                v-if="tier_charge.category == 1">{{ lang('secure_rate') }}</span>
                                                            <span v-else>{{ lang('non_secure_rate') }}</span>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="fontSize15 display-inline-block">
                                                                <span>{{getPricingFee(tier_charge, charge_item)}} </span>
                                                            </div>
    <!--                                                        <div class="fontSize15 display-inline-block"-->
    <!--                                                             v-if="tier_charge.fee_type == 1">-->
    <!--                                                            <span>{{ convertToDecimal(tier_charge.default_perc_charge) }}% </span>-->
    <!--                                                        </div>-->
    <!--                                                        <div class="fontSize15 display-inline-block"-->
    <!--                                                             v-else-if="tier_charge.fee_type == 2">-->
    <!--                                                            <span>{{ formatFee(tier_charge.default_base_charge, charge_item.charge_decimals) }}p </span>-->
    <!--                                                        </div>-->
    <!--                                                        <div v-if="tier_charge.fee_type == 3">-->
    <!--                                                            <div class="fontSize15 display-inline-block">-->
    <!--                                                                <span>{{ convertToDecimal(tier_charge.default_perc_charge) }}%</span>-->
    <!--                                                            </div>-->
    <!--                                                            <span class="fontSize15 display-inline-block">+</span>-->
    <!--                                                            <div class="fontSize15 display-inline-block">-->
    <!--                                                                <span>{{ formatFee(tier_charge.default_base_charge, charge_item.charge_decimals) }}p </span>-->
    <!--                                                            </div>-->
    <!--                                                        </div>-->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div v-else-if="!loading && !!quote.acquiring_offer && quote.acquiring_offer.charge_items.length < 1" class="col-12">
                                <np-notice :notice-class="'alert-info'" :notice="lang('no_pricing_available')"
                                           :dismissable="false"
                                ></np-notice>
                            </div>
                        </template>
                        <template v-if="mode === 'table'">
                            <div class="col-12" v-if="!loading && !!quote.acquiring_offer && !!quote.acquiring_offer.charge_items">
                                <div class="panel-body">
                                    <table class="table table-shades">
                                        <colgroup>
                                            <col class="col-md-020p">
                                            <col v-show="!has_interchange && show_charge.SHOW_SEC_RATE" class="col-md-020p">
                                            <col v-show="!has_interchange && show_charge.SHOW_SEC_BASE" class="col-md-020p">
                                            <col v-show="!has_interchange && show_charge.SHOW_NON_SEC_RATE && !isSimplifiedPricing" class="col-md-020p">
                                            <col v-show="!has_interchange && show_charge.SHOW_NON_SEC_BASE && !isSimplifiedPricing" class="col-md-020p">
                                            <col v-show="has_interchange" class="col-md-020p">
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>{{lang('card')}}</th>
                                            <th v-show="!has_interchange && show_charge.SHOW_SEC_RATE">
                                        <span style="padding: 0px">
                                            {{isSimplifiedPricing ? lang('msc_rate') : lang('secure_rate')}}
                                           <span
                                                   v-if="isSimplifiedPricing ?
                                                    getTooltipText('msc_rate_help_text').length > 0 :
                                                    getTooltipText('secure_rate_help_text').length > 0"
                                                   :title="isSimplifiedPricing ? lang('msc_rate') : lang('secure_rate')"
                                                   :data-popover-content="isSimplifiedPricing ?
                                                            getTooltipText('msc_rate_help_text') :
                                                            getTooltipText('secure_rate_help_text')"
                                                   style="display: inline-block; padding: 0;"
                                                   class="helpBtn addPopover helpHeader">
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </span>
                                            </th>
                                            <th v-show="!has_interchange && show_charge.SHOW_SEC_BASE">
                                                <span style="padding: 0px">
                                                    {{isSimplifiedPricing ? lang('msc_base') : lang('secure_base')}}
                                                   <span
                                                           v-if="isSimplifiedPricing ?
                                                            getTooltipText('msc_base_help_text').length > 0 :
                                                            getTooltipText('secure_base_help_text').length > 0"
                                                           :title="isSimplifiedPricing ? lang('msc_base') : lang('secure_base')"
                                                           :data-popover-content="isSimplifiedPricing ?
                                                            getTooltipText('msc_base_help_text') :
                                                            getTooltipText('secure_base_help_text')"
                                                           style="display: inline-block; padding: 0;"
                                                           class="helpBtn addPopover helpHeader">
                                                        <i tabindex="-1" class="fa fa-info-circle"></i>
                                                    </span>
                                                </span>
                                            </th>
                                            <th v-show="!has_interchange && show_charge.SHOW_NON_SEC_RATE && !isSimplifiedPricing">
                                        <span style="padding: 0px">
                                            {{lang('non_secure_rate')}}
                                           <span
                                                   v-if="getTooltipText('non_secure_rate_help_text').length > 0"
                                                   :title="lang('non_secure_rate')"
                                                   :data-popover-content="getTooltipText('non_secure_rate_help_text')"
                                                   style="display: inline-block; padding: 0;"
                                                   class="helpBtn addPopover helpHeader">
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </span>
                                            </th>
                                            <th v-show="!has_interchange && show_charge.SHOW_NON_SEC_BASE && !isSimplifiedPricing">
                                                <span style="padding: 0px">
                                                    {{lang('non_secure_base')}}
                                                   <span
                                                           v-if="getTooltipText('non_secure_base_help_text').length > 0"
                                                           :title="lang('non_secure_base')"
                                                           :data-popover-content="getTooltipText('non_secure_base_help_text')"
                                                           style="display: inline-block; padding: 0;"
                                                           class="helpBtn addPopover helpHeader">
                                                        <i tabindex="-1" class="fa fa-info-circle"></i>
                                                    </span>
                                                </span>
                                            </th>
                                            <th v-show="has_interchange">
                                        <span style="padding: 0px">
                                            {{lang('interchange_rate')}}
                                           <span
                                               v-if="getTooltipText('interchange_transactions_help_text').length > 0"
                                               :title="lang('interchange_rate')"
                                               :data-popover-content="getTooltipText('interchange_transactions_help_text')"
                                               style="display: inline-block; padding: 0;"
                                               class="helpBtn addPopover helpHeader">
                                                <i tabindex="-1" class="fa fa-info-circle"></i>
                                            </span>
                                        </span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(charge_item, charge_idx) in charges">
                                            <template v-if="charge_item.is_hidden_by_fee_control !== '1' && charge_item.is_boarding_activated === '1'">
                                                <td>
                                                    <div>
                                                        <div style="float: left">
                                                            <span>
                                                                {{ charge_item.charge_item_name }}
                                                            </span>
                                                        </div>
                                                        <div v-if="isSimplifiedPricing  && charge_item.charge_item_help_text.length > 0" style="float: right">
                                                         <span
                                                             :title="lang('description')"
                                                             :data-popover-content="charge_item.charge_item_help_text"
                                                             style="display: inline-block; padding: 0;"
                                                             class="helpBtn addPopover helpHeader">
                                                            <i tabindex="-1" class="fa fa-info-circle"></i>
                                                        </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td v-show="!has_interchange && show_charge.SHOW_SEC_RATE" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('secure_charge_rate') ? charge_item.formatted_charges['secure_charge_rate'] : 'N/A'}}</td>
                                                <td v-show="!has_interchange && show_charge.SHOW_SEC_BASE" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('secure_charge_base') ? charge_item.formatted_charges['secure_charge_base'] : 'N/A'}}</td>
                                                <td v-show="!has_interchange && show_charge.SHOW_NON_SEC_RATE && !isSimplifiedPricing" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('non_secure_charge_rate') ? charge_item.formatted_charges['non_secure_charge_rate'] : 'N/A'}}</td>
                                                <td v-show="!has_interchange && show_charge.SHOW_NON_SEC_BASE && !isSimplifiedPricing" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('non_secure_charge_base') ? charge_item.formatted_charges['non_secure_charge_base'] : 'N/A'}}</td>
                                                <td v-show="has_interchange" style="vertical-align: top">{{charge_item.formatted_charges.hasOwnProperty('interchange_charge') ? charge_item.formatted_charges['interchange_charge'] : 'N/A'}}</td>
                                            </template>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <np-skeleton class="col-12" v-if="loading" :type="'line_pricing'"></np-skeleton>
                            <div v-if="!loading && !!quote.acquiring_offer && !!quote.acquiring_offer.charge_items && quote.acquiring_offer.charge_items.length < 1" class="col-12">
                                <np-notice :notice-class="'alert-info'" :notice="lang('no_pricing_available')"
                                           :dismissable="false"
                                ></np-notice>
                            </div>
                        </template>

                    </div>
                </div>
            </div>
        <template v-if="isSimplifiedPricing && hrlValue">
              <div class="col-12">
                <div class="panel-body">
                  <table class="table table-shades" >
                    <colgroup>
                      <col class="col-md-020p" >
                      <col v-show="show_charge.SHOW_SEC_RATE" class="col-md-020p" >
                      <col v-show="show_charge.SHOW_SEC_BASE"class="col-md-020p" >
                    </colgroup>
                    <tbody>
                    <tr>
                      <td>
                        <div>
                          <div style="float: left">
                            <span>{{lang('high_risk_loading_rate')}}</span>
                          </div>
                          <div style="float: right">
                           <span v-if="!!getTooltipText('hrl_help_text') && getTooltipText('hrl_help_text').length > 0"
                                 :title="lang('high_risk_loading_rate')"
                                  :data-popover-content="getTooltipText('hrl_help_text')"
                                  style="display: inline-block; padding: 0;"
                                  class="helpBtn addPopover helpHeader">
                              <i tabindex="-1" class="fa fa-info-circle"></i>
                            </span>
                          </div>
                        </div>
                      </td>
                      <td v-show="show_charge.SHOW_SEC_RATE">
                    <span>
                      {{hrlValue}}
                    </span>
                      </td>
                      <td v-show="show_charge.SHOW_SEC_BASE"></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>
        </div>
        <div class="row">
<!--            <div class="col-12" v-if="!!quote.acquiring_offer.additional_data && quote.acquiring_offer.additional_data.length > 1 && !this.hide_additional_data">-->
<!--                <div class="panel panel-default">-->
<!--                    <div class="panel-heading">-->
<!--                        <span> {{ lang('offering_additional_data') }}</span>-->
<!--                    </div>-->
<!--                    <div class="row">-->
<!--                        <div class="col-md-12">-->
<!--                            <div class="row">-->
<!--                                <template v-for="(attribute, a_index) in quote.acquiring_offer.additional_data"-->
<!--                                          v-if="!!quote.acquiring_offer.additional_data && quote.acquiring_offer.additional_data.length > 1">-->
<!--                                    <div class="col-md-4" :key="attribute.update_key">-->
<!--                                        <np-select2-->
<!--                                            :label="attribute.category_name"-->
<!--                                            :id="`attribute_${a_index}`"-->
<!--                                            :name="`attribute_${a_index}`"-->
<!--                                            :placeholder="attribute.category_name"-->
<!--                                            :disabled="true"-->
<!--                                            :required="attribute.mandatory_in_offering === '1'"-->
<!--                                            :parameters="attribute.parameters"-->
<!--                                            v-model="attribute.additional_record_external_id">-->
<!--                                        </np-select2>-->
<!--                                    </div>-->
<!--                                </template>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0" v-if="!is_reviewing && loading_finished">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                    <button type="button" class="btn btn-default me-1" @click="doContinue"> {{lang('continue')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import pricingMixin from '../../../utils/pricing-mixin';

    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal, NPNotice, NPPhone, NPPostcodeSearch,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton,
        NPTextArea, NPVat
    } from "netpify/components";
    import {mapState} from "vuex";
    export default {
        name: "ViewPricing",
        mixins: [utilMixin, applicationMixin, pricingMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-notice': NPNotice,
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        data() {
            return {
                mode: 'table', //can be card mode
                page_label: 'take_a_look_at_your_pricing',
                loading: false,
                abortRouteLeave: false,
            }
        },
        metaInfo() {
            return {
                title: this.lang('pricing')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.setAppPageTitle(vm.page_label);
                //check if there is a fee control to hide some acquiring charges.
                //Be noted it works when entering into this page from other tabs. But if refresh the page, the
                //equpmentoffer/onlineoffer is null as they were set later. So add additional function after the offer data was set
                vm.feeControlProcess();
            });
        },
        created() {
            // this.getAcquiringOffer();

        },
        computed: {
            loading_finished: function () {
                return !this.loading;
            }
        },
        methods: {
            goBack: function (){
                this.abortRouteLeave = true;
                this.$router.push({path: this.quote_root_path + 'business/products/'})
            },
            doContinue: function () {
                let vm = this;
                let path_to = this.application_root_path + 'business_details/';
                this.$router.push({path: path_to})
            },
        }
    }
</script>

<style scoped>
    .fontSize15 {
        font-size: 15px;
    }

    .display-inline-block {
        display: inline-block;
    }


    .fee-block {
        font-size: 0.85em;
    }

    .fees-circle {
        border-radius: 50%;
        width: 45px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        border: 1px solid cadetblue;
    }

    .fee-row {
        font-size: 12px;
    }

    /*.fee-name {*/
    /*    !*line-height: 45px;*!*/
    /*}*/
    .charge-wrapper {
        text-align: left;
    }

    input[type="checkbox"]:disabled + label{
    color: yellow !important;
    }

    /*span:not(.markedBottom) {*/
    /*    display: inline-block;*/
    /*    vertical-align: middle;*/
    /*    line-height: normal;*/
    /*}*/
</style>
